import * as angular from 'angular';
import 'angular-ui-router';
import './BlipConversationsInsights.scss';
import { applicationListStateName } from 'modules/application/list';
import { MicroFrontendService } from 'modules/shared/MicroFrontendService';
import { BlipConversationsInsightsController } from './BlipConversationsInsightsController';
import { BlipConversationsInsightsFeatures } from './BlipConversationsInsightsFeatures';
import BlipConversationsInsightsView from './BlipConversationsInsightsView.html';
import { blipConversationsInsightsScriptSource } from 'app.constants';
import { TenantRoles } from 'modules/application/tenant/TenantService';
export const blipConversationsInsightsStateName = 'auth.blipConversationsInsights';
export const blipConversationsInsightsAnyStateName = 'auth.blipConversationsInsights.any';
export default angular
    .module('blipConversationsInsights', ['ui.router'])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state(blipConversationsInsightsStateName, {
            url: '/blip-conversations-insights',
            controller: BlipConversationsInsightsController,
            controllerAs: '$ctrl',
            template: BlipConversationsInsightsView,
            resolve: {
                authorization: fetchBlipConversationsInsightsPermission,
            },
            onEnter: () => {
                return MicroFrontendService.addSource(blipConversationsInsightsScriptSource);
            },
        })
            .state(blipConversationsInsightsAnyStateName, {
            url: '/{path:any}',
            resolve: {
                authorization: fetchBlipConversationsInsightsPermission,
            },
        });
    }])
    .name;
const fetchBlipConversationsInsightsPermission = ['$state', 'InitializeUserService', 'AccountService2', 'TenantService', 'StudioService', async function ($state, InitializeUserService, AccountService2, TenantService, StudioService) {
        await AccountService2.waitForInitialization();
        await InitializeUserService.initFeatureToggle();
        const user = await AccountService2.me();
        const isContractRoleAuthorized = TenantService.isContractRoleAuthorized(user.identity, [TenantRoles.Admin]);
        const IsBlipConversationsInsightsEnabled = await BlipConversationsInsightsFeatures.IsBlipConversationsInsightsEnabled(StudioService);
        const blipConversationsInsightsEnabled = IsBlipConversationsInsightsEnabled && isContractRoleAuthorized;
        if (!blipConversationsInsightsEnabled) {
            $state.go(applicationListStateName);
        }
    }];
